/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { Form } from '@organisms';
import { COL_WITH_EXTRA } from '@constants';

const ParentField = React.forwardRef(
  (
    {
      initialParentItem,
      wrapperCol,
      disabled,
      onChange,
      onSearch,
      showAction,
      placeholder,
      onRedirect,
      linkText,
      children,
      ...props
    },
    ref,
  ) => {
    const [selectedParent, setSelectedParent] = React.useState(initialParentItem);

    const handleChange = (item) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(item);
      setSelectedParent(item);
    };

    return (
      <Form.ItemWithExtra
        wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
        extra={
          !!selectedParent && (
            <Link to={onRedirect(selectedParent)} target="_blank" rel="noopener noreferrer">
              {linkText}
            </Link>
          )
        }
        {...props}
      >
        {children({ onChange: handleChange, ref, disabled, onSearch, showAction, placeholder })}
      </Form.ItemWithExtra>
    );
  },
);

export default ParentField;
